<template>
  <div class="section-visibility-checks-compact">
    <div class="section-header p-1 text-center main">
      <b-col>{{ $t('diagnosis.sidebar.groups') }}</b-col>
    </div>
    <div
      id="visibility-check"
      class="group"
    >
      <div class="check-parent d-flex align-items-center justify-content-center py-2 px-2">
        <div class="px-2">
          <i
            class="fal fa-eye white"
            aria-hidden="true"
          />
        </div>
      </div>
      <b-popover
        triggers="hover"
        :target="'visibility-check'"
        placement="rightbottom"
        :container="'visibility-check'"
        class="popover-sections"
      >
        <div class="menu-popover pop-module check-popover">
          <div
            class="menu-popover-title d-flex align-items-center"
            style="padding: 0 15px"
          >
            <div class="title d-flex justify-content-between align-items-center w-100">
              <span v-if="isGrossing">{{ $t('grossing.sidebar.viewMySamples') }}</span>
              <span v-if="isIncidents">{{ $t('incidents.sidebar.viewMyIncidents') }}</span>
              <span v-if="isDiagnosis">{{ $t('diagnosis.sidebar.viewMyCases') }}</span>
              <div class="switch-btn p-0 d-flex align-items-center">
                <input
                  id="toggleInformSideBarCompact"
                  v-model="checked"
                  type="checkbox"
                  :class="checked ? 'qa-checked' : 'qa-unchecked'"
                  class="offscreen"
                  aria-hidden="true"
                  @change="$emit('view-all-toggled', !checked)"
                >
                <label
                  for="toggleInformSideBarCompact"
                  class="switch mb-0"
                />
              </div>
            </div>
          </div>
        </div>
      </b-popover>
    </div>
  </div>
</template>

<script>
export default {
    name: 'SectionVisibilityChecksCompact',
    props: {
        viewAllEnabled: { type: Boolean, default: false },
        isGrossing: { type: Boolean },
        isIncidents: { type: Boolean },
        isDiagnosis: { type: Boolean }
    },
    data() {
        return {
            checked: !this.viewAllEnabled
        }
    },
    watch: {
        viewAllEnabled(enabled) {
            this.checked = !enabled
        }
    }
}
</script>

<style lang="scss" scoped>
    .section-visibility-checks-compact .check-parent {
        background: vt-color(sidebar-visibility-bg);
        cursor: pointer;
    }

    .section-visibility-checks-compact .section-header {
        display: none;
    }

    .section-visibility-checks-compact .switch-label {
        font-size: font-size(very-small);
        color: vt-color(dark-text);
    }
    .section-visibility-checks-compact .switch {
        position: relative;
        display: inline-block;
        width: 30px;
        height: 16px;
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        transition: all 0.3s;
        cursor: pointer;
    }
    .section-visibility-checks-compact .switch::after {
        content: "";
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 14px;
        background-color: white;
        top: 1px;
        left: 1px;
        transition: all 0.3s;
    }
    .section-visibility-checks-compact input[type="checkbox"]:checked + .switch::after {
        transform: translateX(14px);
    }
    .section-visibility-checks-compact input[type="checkbox"]:checked + .switch {
        background-color: vt-color(primary);
    }
    .section-visibility-checks-compact .offscreen {
        position: absolute;
        left: -9999px;
    }
    .section-visibility-checks-compact .menu-popover {
        width: 200px;
        background: vt-color(sidebar-visibility-bg);
    }

    .check-parent:hover {
        background-color: vt-color(primary);
    }

    .check-parent .title span {
        font-size: font-size(very-small);
        color: #707070;
    }

</style>
